module.exports = __webpack_public_path__ + "static/cola-3c054364b1f2adb70b745565910485ab.jpg";